<template>
	<div>
		<h3>
			<label :for="name">{{ label }}</label>
			<span v-if="required" class="required-field">*</span>
		</h3>
		<Field
			:name="name"
			type="text"
			v-model="inputValue"
			v-slot="{ errorMessage, meta, handleBlur }"
		>
			<select
				name="select"
				:class="{ error: errorMessage && meta.touched }"
				:id="name"
				:disabled="disabled"
				:value="value"
				@blur="handleBlur"
				@change="changeSelect($event.target.value)"
			>
				<option v-if="placeholder" value="" selected>
					{{ placeholder }}
				</option>
				<option
					v-for="(option, idx) in options"
					:key="idx"
					:value="optionValue ? option[optionValue] : option"
				>
					{{ optionText ? option[optionText] : option }}
				</option>
			</select>
			<ErrorMessage v-if="meta.touched" class="errorMsg" :name="name" as="p" />
		</Field>
	</div>
</template>

<script>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { Field, ErrorMessage } from 'vee-validate';

export default {
	name: 'InputSelect',
	props: {
		label: {
			type: String,
		},
		name: {
			type: String,
		},
		placeholder: {
			type: String,
		},
		value: {
			type: String,
		},
		optionValue: {
			type: String,
		},
		optionText: {
			type: String,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		datasource: {
			type: String,
		},
		required: {
			type: Boolean,
		},
	},
	components: { Field, ErrorMessage },
	setup(props, { emit }) {
		const store = useStore();

		const options = ref([]);

		const inputValue = computed({
			get() {
				return props.value;
			},
			set(inputValue) {
				emit('update:value', inputValue);
			},
		});
		const changeSelect = uid => {
			// const option = props.options.find(
			// 	option => option[props.optionValue] === uid,
			// );
			emit('update:value', uid);
			// emit('update:item', option);
		};

		const getOptions = async datasource => {
			options.value = await store.dispatch('common/FETCH_OPTIONS', {
				path: datasource,
			});
		};

		if (props.datasource) {
			getOptions(props.datasource);
		}

		return { inputValue, options, changeSelect };
	},
};
</script>
